import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../shared/spinner.component';

import DropdownMenu from '../../shared/dropdownMenu';
import { changeCursorTo, CursorTypes } from '../../utils/changeCursor';
import { waitForSpinnerToShowUp } from '../../shared/cursorHelpers';

class HamburgerMenu extends PureComponent {
  static propTypes = {
    exportToExcel: PropTypes.func,
    exportToCsv: PropTypes.func,
    isExportingReportForAllPills: PropTypes.bool,
  };

  // eslint-disable-next-line react/sort-comp
  static defaultPropTypes = {
    exportToExcel: null,
    exportToCsv: null,
    isExportingReportForAllPills: false,
  };

  state = {
    isGeneratingXlsxFile: false,
    isGeneratingCsvFile: false,
  };

  isExportInFlight = false;

  componentDidUpdate(prevProps) {
    const isExportingReportForAllPillsChanged = (
      prevProps.isExportingReportForAllPills !== this.props.isExportingReportForAllPills
    );

    if (isExportingReportForAllPillsChanged && prevProps.isExportingReportForAllPills) {
      changeCursorTo(CursorTypes.DEFAULT);
      this.hideDropDown();
      this.isExportInFlight = false;
      this.setState({ isGeneratingXlsxFile: false, isGeneratingCsvFile: false });
    }
  }

  hideDropDown = () => {
    this.dropdown.hideDropDown();
  };

  exportToExcel = () => {
    if (this.isExportInFlight) {
      return;
    }
    this.isExportInFlight = true;
    this.setState({ isGeneratingXlsxFile: true }, () => {
      waitForSpinnerToShowUp({
        action: this.props.exportToExcel,
        callback: () => this.setState({ isGeneratingXlsxFile: false }),
      });
    });
  };

  exportToCsv = () => {
    if (this.isExportInFlight) {
      return;
    }
    this.isExportInFlight = true;
    this.setState({ isGeneratingCsvFile: true }, () => {
      waitForSpinnerToShowUp({
        action: this.props.exportToCsv,
        callback: () => this.setState({ isGeneratingCsvFile: false }),
      });
    });
  };

  render() {
    const { exportToExcel, exportToCsv, isExportingReportForAllPills } = this.props;
    const { isGeneratingXlsxFile, isGeneratingCsvFile } = this.state;
    const isExporting = isExportingReportForAllPills || isGeneratingXlsxFile || isGeneratingCsvFile;

    const exportingLabel = (
      <span>
        <Spinner small/> Exporting
      </span>
    );

    return (
      <DropdownMenu ref={dropdown => this.dropdown = dropdown} contentClassName="hamburger-menu">
        {exportToExcel
          ? (
            <button
              onClick={this.exportToExcel}
              disabled={isExporting}
            >
              {isGeneratingXlsxFile ? exportingLabel : 'Export to Excel'}
            </button>
          )
          : null
        }
        {exportToCsv
          ? (
            <button
              onClick={this.exportToCsv}
              disabled={isExporting}
            >
              {isGeneratingCsvFile ? exportingLabel : 'Export to CSV'}
            </button>
          )
          : null
        }
      </DropdownMenu>
    );
  }
}

export default HamburgerMenu;
